exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Work/Projects/OnlineParser/web2-ui/src/app/helper/info-text/info-text.component.css
// module id = ../../../../../src/app/helper/info-text/info-text.component.css
// module chunks = main